// 통신사 약관 믹스인
import Vue from 'vue'
import { scrollSet } from '@/utils/Methods'
export default Vue.extend({
  data () {
    return {
      headerText: '본인인증', // 헤더 타이틀
      /** 본인인증 */
      birthday: '', // 생년월일
      gender: '', // 뒷자리
      mobileNo: '',
      mobileCo: '1', // 통신사
      name: '',
      registerType: '1',
      domesticAry: '1234',
      foreignerAry: '5678',
      /** 모달 */
      modelCase: 0,
      btnCase: 1,
      addedDiv: null,
      handleCheck: false,
      heightSize: '200px',
      modalToggle: false,
      message: '',
      termsToggle: false,
      beforeAuth: true, // 인증번호 요청 Bool
      showMobilePop: false, // 알뜰폰 선택 팝업
      allCheck: false,
      agreeList: []
    }
  },
  created () {
    this.setTermList()
  },
  computed: {
    nextValidator () {
      // console.log('## nextValidator')
      if (this.birthday.length !== 6 || this.gender.length !== 1 || !this.allCheck || this.mobileNo.length < 9 || this.name.length < 2) {
        return true
      }
      return false
    }
  },
  watch: {
    mobileCo () {
      this.allCheck = false // allCheck - TermMixins 에 있음
      this.setTermList()
    },
    termsToggle () {
      if (this.termsToggle) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').removeAttribute('style')
      }
    }
  },
  methods: {
    setTermList () {
      const termList = []
      termList.push(this.makeTermObject('서비스 이용약관', 35))
      // 통신사별 약관 매핑
      const termMap = {
        1: [ // SKT
          ['개인정보 수집 이용 동의', 43],
          ['고유 식별정보처리 동의', 27],
          ['통신사 이용약관', 33]
        ],
        2: [ // KT
          ['개인정보 수집 이용 동의', 41],
          ['고유 식별정보처리 동의', 25],
          ['통신사 이용약관', 31]
        ],
        3: [ // LGU+
          ['개인정보 수집 이용 동의', 39],
          ['고유 식별정보처리 동의', 23],
          ['통신사 이용약관', 29]
        ],
        5: [ // 알뜰폰 skt
          ['개인정보 수집 이용 동의', 44],
          ['고유 식별정보처리 동의', 28],
          ['통신사 이용약관', 34],
          ['개인정보 제3자 제공 동의(알뜰폰)', 38]
        ],
        6: [ // 알뜰폰 kt
          ['개인정보 수집 이용 동의', 42],
          ['고유 식별정보처리 동의', 26],
          ['통신사 이용약관', 32],
          ['개인정보 제3자 제공 동의(알뜰폰)', 36]
        ],
        7: [ // 알뜰폰 LGU+
          ['개인정보 수집 이용 동의', 40],
          ['고유 식별정보처리 동의', 24],
          ['통신사 이용약관', 30],
          ['개인정보 제3자 제공 동의(알뜰폰)', 37]
        ]
      }
      // this.mobileCo 에 맞는 약관들 추가
      if (termMap[this.mobileCo]) {
        termList.push(
          ...termMap[this.mobileCo].map(([name, seq]) => this.makeTermObject(name, seq))
        )
      }
      this.agreeList = termList // agreeList - TermMixins 에 있음
    },
    makeTermObject (name, seq) {
      const baseUrl = 'https://partner.modnpay.kr/policyView?seq='
      return {
        name: name,
        url: `${baseUrl + seq}`,
        optionFlag: 0,
        isApprove: false
      }
    },
    checkDomestic () {
      const { registerType, gender, domesticAry, foreignerAry } = this
      let result = true
      if (registerType === '1') {
        if (!domesticAry.includes(gender)) {
          console.log('## !domesticAry')
          this.isInvalidInfomation()
          result = false
        }
      } else if (registerType === '2') {
        if (!foreignerAry.includes(gender)) {
          console.log('## !foreignerAry')
          this.isInvalidInfomation()
          result = false
        }
      }
      return result
    },
    modalToggleChange () {
      this.modalToggle = !this.modalToggle
    },
    isInvalidInfomation () {
      this.message = '정보가 일치하지 않습니다<br/>확인 후 다시 시도해주세요'
      this.modalToggleChange()
    },
    essentialFlag (list) {
      return list.optionFlag === 0 ? '[필수]' : '[선택]'
    },
    handleFocus () {
      this.handleCheck = true
      this.addedDiv = scrollSet('.app-wrap', '.full-auth-btn', this.addedDiv, this.handleCheck, this.heightSize)
    },
    handleBlur () {
      this.handleCheck = false
      this.addedDiv = scrollSet('.app-wrap', '.full-auth-btn', this.addedDiv, this.handleCheck, this.heightSize)
    },
    openMobilePop () { // 알뜰폰 팝업
      if (this.beforeAuth) {
        this.showMobilePop = true
      }
    },
    mobileValueChange (value) { // 알뜰폰 선택 mobileCo 변경
      this.mobileCo = value
      this.showMobilePop = false
    }
  }

})
